import React from "react";
import useStyles from "./styles";

import { Grid } from "@material-ui/core";

const Line = () => {
	const classes = useStyles();

	return (
		<Grid classes={{ root: classes.titleDiscount }}>
			<Grid classes={{ root: classes.line }} />
			<Grid classes={{ root: classes.title }}>
				Và được tặng chiết khấu theo hạng mức
			</Grid>
			<Grid classes={{ root: classes.line }} />
		</Grid>
	);
};

export default Line;
